// src/components/PostSignUpModal.tsx

import React from "react";

interface PostSignUpModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  htmlContent: string;
}
const PostSignUpModal: React.FC<PostSignUpModalProps> = ({
  open,
  setOpen,
  htmlContent,
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div
      className={`fixed inset-0 px-2 z-50 overflow-hidden flex items-center justify-center transition-opacity duration-300 ${
        open
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
      onClick={() => setOpen(false)}
    >
      {/* Background overlay */}
      <div className="absolute inset-0 bg-gray-500 bg-opacity-75"></div>

      {/* Modal container */}
      <div
        className={`bg-white rounded-md shadow-xl overflow-hidden max-w-md w-full z-50 transition-all duration-300 transform ${
          open ? "scale-100" : "scale-75"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-4 py-3  bg-red-500  flex justify-between items-center">
          <h2 className="text-lg font-semibold text-white">Hey</h2>
        </div>

        {/* Body (inserting our HTML) */}
        <div className="p-4 text-gray-800 space-y-4 text-sm">
          <div
            className="prose prose-sm"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          ></div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-4 border-t p-4">
          <button
            onClick={() => setOpen(false)}
            className="px-4 py-2 text-sm rounded-md border border-gray-300 hover:bg-gray-100"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostSignUpModal;
